export default "__VITE_ASSET__306f504a__";